import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
} from "@ionic/react";
import CodeResentModal from "../components/modals/code-resent-modal";
import React, { useEffect, useState } from "react";
import { ActionType, BusinessType, MailType } from "../models/Enums";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import {
  ForgotPasswordAuth,
  GetUserByEmail,
  OTPAuth,
  OTPCodeSignupAuth,
} from "../services/AuthServices";
import ErrorTopToaster from "../components/ErrorTopToaster";
import { useRecoilState, useRecoilValue } from "recoil";
import { networkConnectionStatus, newUserState } from "../data/atoms";
import TopLeftUserName from "../components/TopLeftUserName";
import ExitModal from "../components/modals/exit-modal";

interface Props {
  actionType: any;
}

const Code: React.FC<Props> = ({ actionType }) => {
  if (actionType?.actionType) {
    actionType = actionType?.actionType;
  }
  const [showModal, setShowModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [createTagModal, setShowModal2] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  let newUser = useRecoilValue(newUserState);
  const [showToast, setShowToast] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [cancelExitModal, setShowModal1] = useState(false);

  let history = useHistory();
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
    },
  });

  useEffect(() => {
    showToast && setTimeout(() => setShowToast(false), 3000);
  }, [showToast]);

  function clickChange(OTPcode: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (actionType == ActionType.NewUser) {
      VerifyOTPSignup(OTPcode);
      // history.push("/signup");
    } else {
      //ResetPassword(email);
      VerifyOTP(OTPcode);
    }
  }

  async function resendResetPasswordOtp(email: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      //setShowToast(false);
      await ForgotPasswordAuth({
        Email: email,
        MailType: MailType.ResetCodeEmail,
      })
        .then(function (response: any) {
          if (response!.data.responseCode === 1) {
            localStorage.setItem("UserID", response!.data.id);
            localStorage.setItem("TokenID", response!.data.token);
            localStorage.setItem("LocationId", response!.data.locationId);
            localStorage.setItem("WorkstationId", response!.data.workstationId);
            localStorage.setItem("resetEmail", email);
            localStorage.setItem("Username", response!.data.responseMessage);
            localStorage.setItem(
              "EncryptedServerId",
              response!.data.encryptedServerId
            );
            localStorage.setItem("BusinessType", response!.data.businessType);
            reset({ code: "" });

            setShowToast(true);

            //setShowModal(true);
            //  history.push("/code", { actionType: ActionType.ForgotPassword });
          } else {
            // setError("code", {
            //   type: "server",
            //   message: "Incorrect Code.Try again or resend code."
            //   // message: "Unable to send email",
            // });
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function resendCode(email: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      //setShowToast(false);
      await GetUserByEmail({
        email: email,
      })
        .then(function (response) {
          // response!.data != "" &&
          if (response!.data.responseCode == 1) {
            // reset();
            setShowToast(true);

            // setTimeout(() => {
            //   setShowToast(false);
            // }, 5000);

            //setShowModal(true);
            //  history.push("/code", { actionType: ActionType.NewUser });
          } else {
            // setError("email", {
            //   type: "server",
            //   message: "The Email entered is not recognized. Please contact your administrator"
            //   // message: "Unable to send email",
            // });
            // console.log(errors);
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error: any) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
  }

  async function VerifyOTPSignup(OTPcode: string) {
    try {
      //setShowToast(false);
      await OTPCodeSignupAuth({
        otpCode: OTPcode,
        ServerId: newUser.serverId,
      })
        .then(async function (response) {
          if (response!.data.isResponseSuccessfull) {
            reset();
            history.replace("/signup");
          } else {
            setError("code", {
              type: "server",
              message:
                response!.data.errorMessage == "Invalid Code limit exceed"
                  ? response!.data.errorMessage
                  : "Incorrect Code. Try again or resend code.",
            });
          }
        })
        .catch((error) => {
          // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      console.error(error);
    }
  }

  async function VerifyOTP(OTPcode: string) {
    const bType =
      localStorage.getItem("BusinessType") === "2"
        ? BusinessType.DirectConnect
        : BusinessType.Cloud;
    try {
      //setShowToast(false);
      await OTPAuth({
        Code: OTPcode,
        LoggedInUserID: localStorage.getItem("UserID"),
        VerificationToken: localStorage.getItem("TokenID"),
        BusinessType: bType,
      })
        .then(async function (response) {
          if (response!.data.responseCode !== 0) {
            reset();
            localStorage.setItem(
              "BusinessType",
              response!.data.passwordRecoveryToken.businessType
            );
            // history.replace("/password-reset");
            history.replace("/password-reset", { actionType: actionType });
          } else {
            setError("code", {
              type: "server",
              // message: response!.data.responseMessage,
              message:
                response!.data.responseMessage == "Invalid Code limit exceed"
                  ? response!.data.responseMessage
                  : "Incorrect Code.Try again or resend code.",
            });
          }
        })
        .catch((error) => {
          // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      console.error(error);
    }
  }

  async function checkDisableTextValidity(typedValue: string) {
    if (typedValue !== "" && typedValue.trim().length >= 4) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }

  function handleChange(event: any) {
    checkDisableTextValidity(event.target.value);
  }

  console.log("code actiontype ", actionType);

  const actionTypeFlow =
    localStorage.getItem("isOtpFlow") === "true"
      ? ActionType.ExitExpiredPassword
      : ActionType.ExitForgotPassword;

  if (actionType === ActionType.NewUser) {
    return (
      <>
        <IonModal
          className="code-resent-modal"
          backdropDismiss={false}
          isOpen={showModal}
          placeholder={undefined}
        >
          <CodeResentModal setShowModal={setShowModal}></CodeResentModal>
        </IonModal>

        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={cancelExitModal}
          placeholder={undefined}
        >
          <ExitModal
            setShowModal1={setShowModal1}
            actionType={ActionType.NewUser}
            reset={reset}
            isEdit={false}
          ></ExitModal>
        </IonModal>

        <IonPage placeholder={undefined}>
          <TopLeftUserName
            headerText={"Account Registration"}
            actionType={ActionType.ExitUserSetup}
            exitModal={() => setShowModal1(true)}
          ></TopLeftUserName>
          <IonContent placeholder={undefined} className="slide-in-right">
            <IonGrid
              className="container login-pages-top-spacing"
              placeholder={undefined}
            >
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="top-inner-sec login-pages-space">
                    <h1>Email Sent</h1>
                    <p className="text-center">
                      A code has been sent to your email. Enter the code here to
                      confirm your email.
                    </p>
                  </div>
                  <form
                    onSubmit={handleSubmit((data) => {
                      clickChange(data.code);
                    })}
                  >
                    <div className="field-wrap disabled">
                      <IonLabel className="label" placeholder={undefined}>
                        Email*
                      </IonLabel>
                      <span className="input-field">
                        {localStorage.getItem("resetEmail")!}
                      </span>
                    </div>
                    <div className="field-links resend-code">
                      <span
                        onClick={() => {
                          //now resend code will work for only sigup new user not for forgot password
                          resendCode(newUser.email);
                        }}
                      >
                        Resend code
                      </span>
                    </div>
                    <div
                      className={`field-wrap ${errors.code && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        OTP Code*
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="XXXX"
                        {...register("code", { required: true })}
                        onIonChange={(e) => {
                          handleChange(e);
                        }}
                      ></IonInput>
                      {showToast && (
                        <ErrorTopToaster errorString={"Code Resent."} />
                      )}
                      <div className="error-wrap">
                        {errors.code &&
                          errors.code.type !== "required" &&
                          errors.code.type === "server" &&
                          errors.code.message && (
                            <p className="error-msg">{errors.code.message}</p>
                          )}
                      </div>
                    </div>
                    <div className="login-btn-fixed-bottom">
                      <div className="btn-wrap-sec two-btns only-code-page-extra-btn-space-wrap">
                        <IonButton
                          className="generic-btn generic-btn-outline"
                          // onClick={() => setCancelModal(true)}
                          onClick={() => {
                            reset();
                            setShowToast(false);
                            history.replace("/email", {
                              actionType: ActionType.NewUser,
                            });
                          }}
                          placeholder={undefined}
                        >
                          Back
                        </IonButton>

                        <IonButton
                          className="generic-btn"
                          type="submit"
                          disabled={isDisabled}
                          placeholder={undefined}
                        >
                          Confirm
                        </IonButton>
                      </div>
                    </div>
                  </form>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        </IonPage>
      </>
    );
  } else if (actionType === ActionType.ForgotPassword) {
    return (
      <>
        <IonModal
          className="code-resent-modal"
          backdropDismiss={false}
          isOpen={showModal}
          placeholder={undefined}
        >
          <CodeResentModal setShowModal={setShowModal}></CodeResentModal>
        </IonModal>

        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={cancelExitModal}
          placeholder={undefined}
        >
          <ExitModal
            setShowModal1={setShowModal1}
            actionType={actionTypeFlow}
            reset={reset}
            isEdit={false}
          ></ExitModal>
        </IonModal>

        <IonPage placeholder={undefined}>
          <TopLeftUserName
            headerText={"Password Reset"}
            actionType={ActionType.ExitForgotPassword}
            exitModal={() => setShowModal1(true)}
          ></TopLeftUserName>

          <IonContent placeholder={undefined} className="slide-in-right">
            <IonGrid
              className="container login-pages-top-spacing"
              placeholder={undefined}
            >
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="top-inner-sec login-pages-space">
                    <h1>
                      {/* <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="tick-icon-new"
                      >
                        <path
                          d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
                          stroke="#802392"
                          strokeWidth="2"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M17 10.333L11.6667 15.6663L9 12.9997"
                          stroke="#802392"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg> */}
                      Email Sent
                    </h1>
                    <p className="text-center">
                      A code has been sent to your email. Enter the code here to
                      confirm your email.
                    </p>
                  </div>

                  <form
                    onSubmit={handleSubmit((data) => {
                      clickChange(data.code);
                    })}
                  >
                    <div className="field-wrap disabled">
                      <IonLabel className="label" placeholder={undefined}>
                        Email*
                      </IonLabel>
                      <span className="input-field">
                        {localStorage.getItem("resetEmail")!}
                      </span>
                    </div>
                    <div className="field-links resend-code">
                      <span
                        onClick={() => {
                          //now resend code will work for only sigup new user not for forgot password
                          resendResetPasswordOtp(
                            localStorage.getItem("resetEmail")!
                          );
                        }}
                      >
                        Resend code
                      </span>
                    </div>

                    <div
                      className={`field-wrap ${errors.code && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        OTP Code*
                      </IonLabel>

                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="XXXX"
                        {...register("code", { required: true })}
                        onIonChange={(e) => {
                          handleChange(e);
                        }}
                      ></IonInput>

                      {showToast && (
                        <ErrorTopToaster errorString={"Code Resent."} />
                      )}

                      <div className="error-wrap">
                        {errors.code &&
                          errors.code.type !== "required" &&
                          errors.code.type === "server" &&
                          errors.code.message && (
                            <p className="error-msg">{errors.code.message}</p>
                          )}
                      </div>
                    </div>

                    <div className="btn-wrap-sec two-btns only-code-page-extra-btn-space-wrap">
                      <IonButton
                        className="generic-btn generic-btn-outline"
                        onClick={() => {
                          reset();
                          setShowToast(false);
                          if (localStorage.getItem("isOtpFlow") === "true") {
                            localStorage.setItem("isOtpFlow", "false");
                            history.replace("/login");
                          } else {
                            history.replace("/email", {
                              actionType: ActionType.ForgotPassword,
                            });
                          }
                        }}
                        placeholder={undefined}
                      >
                        Back
                      </IonButton>

                      <IonButton
                        className="generic-btn"
                        type="submit"
                        disabled={isDisabled}
                        placeholder={undefined}
                      >
                        Confirm
                      </IonButton>
                    </div>
                  </form>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        </IonPage>
      </>
    );
  } else return <></>;
};
export default Code;
